module.exports = {BAQualificationPage:{content:[]},BARiskAnalysisPage:{pasFlowStepId:'BusinessVehicles',content:[{entityType:'entity.BusinessAutoLine'}]}}